module.exports = __webpack_public_path__ + "res/img/loading.e545de09.gif";